"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const detect_node_1 = __importDefault(require("detect-node"));
const semver_compare_1 = __importDefault(require("semver-compare"));
const config_1 = require("../config");
const createNodeWriter_1 = __importDefault(require("./createNodeWriter"));
exports.default = (currentState) => {
    const versions = (currentState.versions || []).concat();
    if (versions.length > 1) {
        versions.sort(semver_compare_1.default);
    }
    const currentIsLatestVersion = !versions.length || semver_compare_1.default(config_1.ROARR_VERSION, versions[versions.length - 1]) === 1;
    if (!versions.includes(config_1.ROARR_VERSION)) {
        versions.push(config_1.ROARR_VERSION);
    }
    versions.sort(semver_compare_1.default);
    let newState = {
        sequence: 0,
        ...currentState,
        versions,
    };
    if (detect_node_1.default && (currentIsLatestVersion || !newState.write)) {
        newState = {
            ...newState,
            ...createNodeWriter_1.default(),
        };
    }
    return newState;
};
